import React from 'react';

import { LazyCodeMacroConfigurationPage } from '@confluence/site-settings/entry-points/ConfigureCodeMacroPage.ts';
import { ADMIN_CONFIGURE_CODE_MACRO_ANALYTICS_SOURCE } from '@confluence/site-settings/entry-points/configureCodeMacroConstants.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

export const AdminCodeMacroConfigurationRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => <LazyCodeMacroConfigurationPage />;

AdminCodeMacroConfigurationRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: { name: ADMIN_CONFIGURE_CODE_MACRO_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
